import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-subscription-type-districtwise',
  templateUrl: './subscription-type-districtwise.component.html',
  styleUrls: ['./subscription-type-districtwise.component.scss']
})
export class SubscriptionTypeDistrictwiseComponent implements OnInit {

  isLoading = false;

  startDate = '';
  endDate   = '';

  /** Today's date — shown in print header as मुद्रण दिनांक */
  today: Date = new Date();

  subData: any[] = [];

  districtwiseData: any[]      = [];
  districtwiseDataTotal: any   = {};
  districtwiseDataTotalTest: any = {};

  subTypesName: any[] = [
    { name: 'वार्षिक',                          isVisible: false },
    { name: 'त्रैवार्षिक',                      isVisible: false },
    { name: 'पंचवार्षिक',                       isVisible: false },
    { name: 'मुदत ठेव (पंचवार्षिक वर्गणीदार)', isVisible: false },
  ];

  excludedTypes = [
    'हितचिंतक सप्रेम भेट',
    'सप्रेम भेट - संपादकीय विभाग',
    'जाहिरात स. भेट',
    'संघ परिवार सप्रेम भेट',
    'वर्गणी सप्रेम भेट',
  ];

  /**
   * totalth = (visible sub-types × 5 cols)
   *         + 2  (अनु क्र. + जिल्हा leading)
   *         + 5  (grand total cols)
   *         + 1  (trailing जिल्हा col)
   * = visible * 5 + 8
   */
  totalth = 8;

  // ── filter values from parent ──
  selectedCountry:      string = '';
  selectedState:        string = '';
  selectedDistrict:     string = '';
  selectedSubType:      string = '';
  selectedPrant:        string = '';
  selectedRepName:      string = '';
  selectedOfficer:      string = '';
  selectedDeliveryMode: string = '';

  constructor(
    private service: DigisubservicesService,
    private dialogRef: MatDialogRef<SubscriptionTypeDistrictwiseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  // ngOnInit(): void {
  //   this.startDate            = this.data.startDate    || '';
  //   this.endDate              = this.data.endDate      || '';
  //   this.selectedCountry      = this.data.country      || '';
  //   this.selectedState        = this.data.state        || '';
  //   this.selectedDistrict     = this.data.districtName || '';
  //   this.selectedSubType      = this.data.subType      || '';
  //   this.selectedPrant        = this.data.prantname    || '';
  //   this.selectedRepName      = this.data.repName      || '';
  //   this.selectedOfficer      = this.data.offRepName   || '';
  //   this.selectedDeliveryMode = this.data.deliveryMode || '';

    
    

  //   this.loadReport();
  // }

  ngOnInit(): void {
    console.log('Dialog received data:', this.data); // debug - remove after fix confirmed

    this.startDate = this.data.startDate || '';
    this.endDate   = this.data.endDate   || '';

    this.selectedCountry  = this.data.country      || '';
    this.selectedState    = this.data.state        || '';
    this.selectedDistrict = this.data.districtName || '';
    this.selectedPrant    = this.data.prantname    || '';
    this.selectedRepName  = this.data.repName      || '';
    this.selectedOfficer  = this.data.offRepName   || '';

    // ✅ FIX: parent passes snake_case keys, not camelCase
    this.selectedSubType      = this.data.sub_type      || '';  // was this.data.subType      ❌
    this.selectedDeliveryMode = this.data.delivery_mode || '';  // was this.data.deliveryMode ❌

    console.log('sub_type:', this.selectedSubType);
    console.log('delivery_mode:', this.selectedDeliveryMode);

    this.loadReport();
  }

  getKey(name: string): string {
    return name.replace(/\s+/g, '_');
  }

  // ── Load report ──────────────────────────────────────────────────────
  loadReport(): void {
    this.isLoading = true;

  const payload = {
  start_date: this.startDate,
  end_date: this.endDate,
  country: this.selectedCountry || '',
  state: this.selectedState || '',
  district: this.selectedDistrict || '',
  prant_name: this.selectedPrant || '',
  rep_name: this.selectedRepName || '',
  off_rep_name: this.selectedOfficer || '',
  delivery_mode: this.selectedDeliveryMode || '',
  sub_type: this.selectedSubType || '',
};

console.log('FINAL Payload:', payload);

    console.log('Report Payload:', payload);

    this.service.getDistrictwiseSubscription(payload).subscribe({
      next: (response: any) => {
        this.subData = Array.isArray(response) ? response : response?.data || [];
        this.districtwiseData          = [];
        this.districtwiseDataTotal     = {};
        this.districtwiseDataTotalTest = {};
        this.initializeSubTypes();
        this.setSubData();
      },
      error: (err) => {
        console.error('Report load error:', err);
        this.isLoading = false;
      }
    });
  }

  

  // ── Init sub-type columns ─────────────────────────────────────────────
  initializeSubTypes(): void {
    const unique = this.uniqueDataByKey(this.subData, 'Subscription_Type');
    this.subTypesName.forEach(s => s.isVisible = false);

    unique.forEach((item: any) => {
      const found = this.subTypesName.find(s => s.name === item.Subscription_Type);
      if (found) {
        found.isVisible = true;
      } else if (item.Subscription_Type && !this.excludedTypes.includes(item.Subscription_Type)) {
        this.subTypesName.push({ name: item.Subscription_Type, isVisible: true });
      }
    });

    const visibleCount = this.subTypesName.filter(b => b.isVisible).length;
    // 2 (leading) + visibleCount*5 + 5 (grand total) + 1 (trailing district)
    this.totalth = visibleCount * 5 + 8;

    // Reset totals structure
    this.districtwiseDataTotalTest = {};
    this.subTypesName.forEach((a: any) => {
      const key = this.getKey(a.name);
      this.districtwiseDataTotalTest[key + '_पोस्ट']   = 0;
      this.districtwiseDataTotalTest[key + '_हस्ते']   = 0;
      this.districtwiseDataTotalTest[key + '_मॅगझीन'] = 0;
      this.districtwiseDataTotalTest[key + '_डिजिटल'] = 0;
      this.districtwiseDataTotalTest[key + '_एकूण']   = 0;
    });

    this.districtwiseDataTotal = {
      ...this.districtwiseDataTotalTest,
      एकूण_पोस्ट:   0,
      एकूण_हस्ते:   0,
      एकूण_मॅगझीन: 0,
      एकूण_डिजिटल: 0,
      एकूण:         0,
    };
  }

  // ── Process rows ──────────────────────────────────────────────────────
  setSubData(): void {
    const districts = this.uniqueDataByKey(this.subData, 'district');
    districts.sort((a: any, b: any) => a.district.localeCompare(b.district, 'mr-IN'));

    districts.forEach((d: any) => {
      const districtRows = this.subData.filter(a => a.district === d.district);
      const subTypes     = this.uniqueDataByKey(districtRows, 'Subscription_Type');

      subTypes.forEach((sub: any) => {
        const typeRows = districtRows.filter(a => a.Subscription_Type === sub.Subscription_Type);
        const post     = typeRows.filter(a => a.delivery_mode === 'टपाल').length;
        const haste    = typeRows.filter(a => a.delivery_mode === 'हस्ते').length;
        const magazine = typeRows.filter(a => a.delivery_mode === 'मॅगझीन पोस्ट').length;
        const digital  = typeRows.filter(a => a.delivery_mode === 'डिजिटल').length;
        this.setSubTypeData(d.district, this.getKey(sub.Subscription_Type), post, haste, magazine, digital);
      });
    });

    this.calculateTotal();
  }

  // setSubTypeData(
  //   districtName: string, subType: string,
  //   post: number, haste: number, magazine: number, digital: number
  // ): void {
  //   let found = this.districtwiseData.find(a => a.districtName === districtName);

  //   if (!found) {
  //     found = {
  //       districtName,
  //       ...this.districtwiseDataTotalTest,
  //       एकूण_पोस्ट: 0, एकूण_हस्ते: 0, एकूण_मॅगझीन: 0, एकूण_डिजिटल: 0, एकूण: 0,
  //     };
  //     this.districtwiseData.push(found);
  //   }

  //   found[subType + '_पोस्ट']   = post;
  //   found[subType + '_हस्ते']   = haste;
  //   found[subType + '_मॅगझीन'] = magazine;
  //   found[subType + '_डिजिटल'] = digital;
  //   found[subType + '_एकूण']   = post + haste + magazine + digital;

  //   found['एकूण_पोस्ट']   += post;
  //   found['एकूण_हस्ते']   += haste;
  //   found['एकूण_मॅगझीन'] += magazine;
  //   found['एकूण_डिजिटल'] += digital;
  //   found['एकूण']         += post + haste + magazine + digital;
  // }

  // calculateTotal(): void {
  //   this.districtwiseData.forEach(row => {
  //     this.subTypesName.forEach(s => {
  //       const key = this.getKey(s.name);
  //       this.districtwiseDataTotal[key + '_पोस्ट']   += row[key + '_पोस्ट']   || 0;
  //       this.districtwiseDataTotal[key + '_हस्ते']   += row[key + '_हस्ते']   || 0;
  //       this.districtwiseDataTotal[key + '_मॅगझीन'] += row[key + '_मॅगझीन'] || 0;
  //       this.districtwiseDataTotal[key + '_डिजिटल'] += row[key + '_डिजिटल'] || 0;
  //       this.districtwiseDataTotal[key + '_एकूण']   += row[key + '_एकूण']   || 0;
  //     });
  //     this.districtwiseDataTotal['एकूण_पोस्ट']   += row['एकूण_पोस्ट']   || 0;
  //     this.districtwiseDataTotal['एकूण_हस्ते']   += row['एकूण_हस्ते']   || 0;
  //     this.districtwiseDataTotal['एकूण_मॅगझीन'] += row['एकूण_मॅगझीन'] || 0;
  //     this.districtwiseDataTotal['एकूण_डिजिटल'] += row['एकूण_डिजिटल'] || 0;
  //     this.districtwiseDataTotal['एकूण']         += row['एकूण']         || 0;
  //   });
  //   this.isLoading = false;
  // }

  // ── Utils ─────────────────────────────────────────────────────────────
  uniqueDataByKey(data: any[], key: string): any[] {
    if (!data) return [];
    return [...new Map(data.map(a => [a[key], a])).values()];
  }

  // ── Print ─────────────────────────────────────────────────────────────
  show = false;
  // printPage(): void {
  //   this.show = true;
  //   const printContent = document.getElementById('print-section')?.outerHTML;
  //   if (!printContent) { console.error('Print section not found!'); return; }

  //   const printWindow = window.open('', '', 'width=1400,height=900,top=50,left=50,scrollbars=yes');
  //   if (!printWindow) { console.error('Failed to open print window.'); return; }

  //   printWindow.document.open();
  //   printWindow.document.write(`
  //     <html>
  //       <head>
  //         <title>वर्गणी प्रकारानुसार जिल्हानिहाय अहवाल</title>
  //         <style>
  //           @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;700&display=swap');

  //           * { box-sizing: border-box; margin: 0; padding: 0; }

  //           body {
  //             font-family: 'Noto Sans Devanagari', Arial, sans-serif;
  //             font-size: 11px;
  //             color: #000;
  //             background: #fff;
  //           }

  //           #print-section {
  //             width: 100%;
  //             padding: 4mm;
  //           }

  //           table {
  //             width: 100%;
  //             border-collapse: collapse;
  //             table-layout: auto;
  //           }

  //           /* ✅ thead repeats on every printed page */
  //           thead {
  //             display: table-header-group;
  //           }
  //           tbody {
  //             display: table-row-group;
  //           }

  //           th, td {
  //             border: 1px solid #000;
  //             padding: 3px 4px;
  //             font-size: 10.5px;
  //             line-height: 1.3;
  //             color: #000;
  //           }

  //           th {
  //             font-weight: bold;
  //           }

  //           /* prevent a data row from splitting across pages */
  //           tr {
  //             page-break-inside: avoid;
  //           }

  //           .noPrint { display: none !important; }

  //           @page {
  //             size: A3 landscape;
  //             margin: 8mm 6mm;
  //           }
  //         </style>
  //       </head>
  //       <body>
  //         <div id="print-section">${printContent}</div>
  //         <script>
  //           window.onload = function () {
  //             window.print();
  //             setTimeout(function () { window.close(); }, 600);
  //           };
  //         </script>
  //       </body>
  //     </html>
  //   `);
  //   printWindow.document.close();
  // }

printPage(): void {
  this.show = true;

  const printSection = document.getElementById('print-section');
  if (!printSection) {
    console.error('Print section not found!');
    return;
  }

  const clonedContent = printSection.cloneNode(true) as HTMLElement;

  // Convert <tfoot> → <tbody> so totals don't repeat on every page
  const tfoot = clonedContent.querySelector('tfoot');
  if (tfoot) {
    const tbody = document.createElement('tbody');
    tbody.innerHTML = tfoot.innerHTML;
    tbody.classList.add('totals-row-section');
    tfoot.parentNode?.replaceChild(tbody, tfoot);
  }

  // Pre-process every cell
  clonedContent.querySelectorAll('td, th').forEach((cell: Element) => {
  const el = cell as HTMLElement;
  const inlineStyle = el.getAttribute('style') || '';

  const isNowrap = el.classList.contains('print-nowrap');

  el.style.removeProperty('width');
  el.style.removeProperty('min-width');
  el.style.removeProperty('max-width');
  el.style.transform     = 'none';
  el.style.padding       = '2px 3px';
  el.style.lineHeight    = '1.3';
  el.style.verticalAlign = 'middle';

  // ✅ Detect numeric cells
  const isNumber = !isNaN(Number(el.innerText.trim()));

  if (isNowrap) {
    el.style.textAlign  = 'left';
    el.style.whiteSpace = 'nowrap';
    el.style.overflow   = 'visible';

  } else if (isNumber || inlineStyle.includes('text-align:right')) {
    // ✅ KEY FIX for numbers
    el.style.textAlign      = 'right';
    el.style.whiteSpace     = 'nowrap';
    el.style.wordBreak      = 'keep-all';
    el.style.overflowWrap   = 'normal';

  } else if (el.tagName === 'TH') {
    el.style.textAlign  = 'center';
    el.style.whiteSpace = 'normal';
    el.style.wordBreak  = 'break-word';

  } else {
    el.style.textAlign  = 'left';
    el.style.whiteSpace = 'normal';
    el.style.wordBreak  = 'break-word';
  }
});

  // Strip fixed widths from tables
  clonedContent.querySelectorAll('table').forEach((table: Element) => {
    const t = table as HTMLElement;
    t.style.tableLayout = 'auto';
    t.style.width       = '100%';
    t.style.removeProperty('min-width');
    t.style.removeProperty('max-width');
  });

  const printWindow = window.open(
    '', '_blank',
    'width=1500,height=950,scrollbars=yes,top=30,left=30'
  );
  if (!printWindow) {
    console.error('Failed to open print window.');
    return;
  }

  printWindow.document.open();
  printWindow.document.write(`
<!DOCTYPE html>
<html lang="mr">
<head>
  <meta charset="UTF-8">
  <title>वर्गणी प्रकारानुसार जिल्हानिहाय अहवाल</title>
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;700&display=swap">
  <style>

    @page {
      size: A3 landscape;
      margin: 6mm 5mm;
    }

    * { box-sizing: border-box; margin: 0; padding: 0; }

    html { width: 420mm; }

    body {
      width: 420mm;
      max-width: 420mm;
      overflow-x: hidden;
      font-family: 'Noto Sans Devanagari', Arial, sans-serif;
      font-size: 9.5px;
      color: #000;
      background: #fff;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    table {
      border-collapse: collapse;
      table-layout: auto;
      width: 100%;
    }

    thead { display: table-header-group; }
    tbody { display: table-row-group;    }
    tfoot { display: none !important;    }

    th, td {
      border: 1px solid #000;
      font-size: 9.5px;
      line-height: 1.4;
      color: #000;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    th { font-weight: bold; }

    /* ✅ KEY FIX — district name column never wraps */
    td.print-nowrap {
      white-space: nowrap !important;
      overflow: visible !important;
      word-break: keep-all !important;
    }

    /* Prevent rows splitting across pages */
    tr {
      page-break-inside : avoid !important;
      break-inside       : avoid !important;
    }

    td, th {
      page-break-inside : avoid !important;
      break-inside       : avoid !important;
    }

    .totals-row-section {
      page-break-before : avoid !important;
      break-before       : avoid !important;
      page-break-inside : avoid !important;
      break-inside       : avoid !important;
    }

    .totals-row-section td {
      font-weight: 700;
      background-color: #c8c8c8 !important;
      border: 2px solid #000 !important;
    }

    @media print {
      html, body { width: 420mm; max-width: 420mm; }

      tr {
        page-break-inside : avoid !important;
        break-inside       : avoid !important;
      }

      td, th {
        page-break-inside : avoid !important;
        break-inside       : avoid !important;
      }

      /* ✅ Reinforce nowrap inside @media print */
      td.print-nowrap {
        white-space: nowrap !important;
        word-break: keep-all !important;
      }

      .noPrint { display: none !important; }
    }

    .noPrint { display: none !important; }

  </style>
</head>
<body>
  ${clonedContent.outerHTML}

  <script>
    document.querySelectorAll('td, th').forEach(function (cell) {
      cell.style.transform = 'none';
      cell.style.removeProperty('width');
      cell.style.removeProperty('min-width');
      cell.style.removeProperty('max-width');

      // ✅ Preserve nowrap for district name cells
      if (cell.classList.contains('print-nowrap')) {
        cell.style.whiteSpace = 'nowrap';
        cell.style.textAlign  = 'left';
        return;
      }

      var s = cell.getAttribute('style') || '';
      if (s.includes('text-align:right') || s.includes('text-align: right')) {
        cell.style.textAlign  = 'right';
        cell.style.whiteSpace = 'nowrap';
      } else if (cell.tagName === 'TH') {
        cell.style.textAlign  = 'center';
        cell.style.whiteSpace = 'normal';
      } else {
        cell.style.textAlign  = 'left';
        cell.style.whiteSpace = 'normal';
      }
    });

    document.querySelectorAll('table').forEach(function (t) {
      t.style.tableLayout = 'auto';
      t.style.width       = '100%';
      t.style.removeProperty('min-width');
    });

    function triggerPrint() {
      window.print();
      setTimeout(function () { window.close(); }, 1200);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready
        .then(function () { setTimeout(triggerPrint, 200); })
        .catch(function () { setTimeout(triggerPrint, 1000); });
    } else {
      window.onload = function () { setTimeout(triggerPrint, 1000); };
    }
  <\/script>
</body>
</html>
  `);
  printWindow.document.close();
}



  calculateTotal(): void {
  // ✅ STEP 1: Sum all values first (keep as numbers)
  this.districtwiseData.forEach(row => {
    this.subTypesName.forEach(s => {
      const key = this.getKey(s.name);
      this.districtwiseDataTotal[key + '_पोस्ट']   += row[key + '_पोस्ट']   || 0;
      this.districtwiseDataTotal[key + '_हस्ते']   += row[key + '_हस्ते']   || 0;
      this.districtwiseDataTotal[key + '_मॅगझीन'] += row[key + '_मॅगझीन'] || 0;
      this.districtwiseDataTotal[key + '_डिजिटल'] += row[key + '_डिजिटल'] || 0;
      this.districtwiseDataTotal[key + '_एकूण']   += row[key + '_एकूण']   || 0;
    });
    this.districtwiseDataTotal['एकूण_पोस्ट']   += row['एकूण_पोस्ट']   || 0;
    this.districtwiseDataTotal['एकूण_हस्ते']   += row['एकूण_हस्ते']   || 0;
    this.districtwiseDataTotal['एकूण_मॅगझीन'] += row['एकूण_मॅगझीन'] || 0;
    this.districtwiseDataTotal['एकूण_डिजिटल'] += row['एकूण_डिजिटल'] || 0;
    this.districtwiseDataTotal['एकूण']         += row['एकूण']         || 0;
  });

  // ✅ STEP 2: Blank zeros in each district data row
  this.districtwiseData.forEach(row => {
    this.subTypesName.forEach(s => {
      const key = this.getKey(s.name);
      if (!row[key + '_पोस्ट']   || row[key + '_पोस्ट']   === 0) row[key + '_पोस्ट']   = '';
      if (!row[key + '_हस्ते']   || row[key + '_हस्ते']   === 0) row[key + '_हस्ते']   = '';
      if (!row[key + '_मॅगझीन'] || row[key + '_मॅगझीन'] === 0) row[key + '_मॅगझीन'] = '';
      if (!row[key + '_डिजिटल'] || row[key + '_डिजिटल'] === 0) row[key + '_डिजिटल'] = '';
      if (!row[key + '_एकूण']   || row[key + '_एकूण']   === 0) row[key + '_एकूण']   = '';
    });
    if (!row['एकूण_पोस्ट']   || row['एकूण_पोस्ट']   === 0) row['एकूण_पोस्ट']   = '';
    if (!row['एकूण_हस्ते']   || row['एकूण_हस्ते']   === 0) row['एकूण_हस्ते']   = '';
    if (!row['एकूण_मॅगझीन'] || row['एकूण_मॅगझीन'] === 0) row['एकूण_मॅगझीन'] = '';
    if (!row['एकूण_डिजिटल'] || row['एकूण_डिजिटल'] === 0) row['एकूण_डिजिटल'] = '';
    if (!row['एकूण']         || row['एकूण']         === 0) row['एकूण']         = '';
  });

  // ✅ STEP 3: Blank zeros in grand total footer row
  this.subTypesName.forEach(s => {
    const key = this.getKey(s.name);
    if (this.districtwiseDataTotal[key + '_पोस्ट']   === 0) this.districtwiseDataTotal[key + '_पोस्ट']   = '';
    if (this.districtwiseDataTotal[key + '_हस्ते']   === 0) this.districtwiseDataTotal[key + '_हस्ते']   = '';
    if (this.districtwiseDataTotal[key + '_मॅगझीन'] === 0) this.districtwiseDataTotal[key + '_मॅगझीन'] = '';
    if (this.districtwiseDataTotal[key + '_डिजिटल'] === 0) this.districtwiseDataTotal[key + '_डिजिटल'] = '';
    if (this.districtwiseDataTotal[key + '_एकूण']   === 0) this.districtwiseDataTotal[key + '_एकूण']   = '';
  });
  if (this.districtwiseDataTotal['एकूण_पोस्ट']   === 0) this.districtwiseDataTotal['एकूण_पोस्ट']   = '';
  if (this.districtwiseDataTotal['एकूण_हस्ते']   === 0) this.districtwiseDataTotal['एकूण_हस्ते']   = '';
  if (this.districtwiseDataTotal['एकूण_मॅगझीन'] === 0) this.districtwiseDataTotal['एकूण_मॅगझीन'] = '';
  if (this.districtwiseDataTotal['एकूण_डिजिटल'] === 0) this.districtwiseDataTotal['एकूण_डिजिटल'] = '';
  if (this.districtwiseDataTotal['एकूण']         === 0) this.districtwiseDataTotal['एकूण']         = '';

  this.isLoading = false;
}

  setSubTypeData(
  districtName: string, subType: string,
  post: number, haste: number, magazine: number, digital: number
): void {
  let found = this.districtwiseData.find(a => a.districtName === districtName);

  if (!found) {
    found = {
      districtName,
      ...this.districtwiseDataTotalTest,
      एकूण_पोस्ट: 0, एकूण_हस्ते: 0, एकूण_मॅगझीन: 0, एकूण_डिजिटल: 0, एकूण: 0,
    };
    this.districtwiseData.push(found);
  }

  found[subType + '_पोस्ट']   = post;
  found[subType + '_हस्ते']   = haste;
  found[subType + '_मॅगझीन'] = magazine;
  found[subType + '_डिजिटल'] = digital;
  found[subType + '_एकूण']   = post + haste + magazine + digital;

  found['एकूण_पोस्ट']   += post;
  found['एकूण_हस्ते']   += haste;
  found['एकूण_मॅगझीन'] += magazine;
  found['एकूण_डिजिटल'] += digital;
  found['एकूण']         += post + haste + magazine + digital;
}

  // ── Export ────────────────────────────────────────────────────────────
  exportExcel(fileName: string): void {
    const element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook  = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, fileName + '.xlsx');
  }
}